module.exports = __webpack_public_path__ + "img/vignette_logo_black.44dbf1a3.svg";